'use client'

import { useSidebar } from '@/components/ui/sidebar'

export function NavSeparator() {
  const { state: _state } = useSidebar()
  
  return (
    <div className="my-2">
      <div className="h-px bg-border w-full" />
    </div>
  )
}
